module.exports = __webpack_public_path__ + "09bf655e.svg";